import Card from '../..';
import { Enum_Bookmark_Category, KnowledgeBase } from '@edwin-group/people-graphql';
import { getAuthors } from '@/services/knowledge-base/utils';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';

const GenericKnowledgeBaseCard = ({
  knowledgebase,
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  knowledgebase: KnowledgeBase;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  const navigate = useNavigate();

  const CardButton = () => {
    const link = `/knowledge-base/${knowledgebase.attributes?.slug}`;

    return (
      <div className="rows-span-1 flex flex-col items-start gap-1">
        <Button
          theme="solid-primary-600"
          onClick={() => {
            if (link) {
              navigate(link);
            }
          }}>
          Learn more
        </Button>
      </div>
    );
  };

  return (
    <Card
      key={knowledgebase?.attributes?.slug}
      title={knowledgebase.attributes?.title || ''}
      description={knowledgebase.attributes?.briefDescription || ''}
      author={getAuthors(knowledgebase)}
      tags={
        <DefaultContentTemplateTags
          tags={[knowledgebase?.attributes?.knowledgeBaseType?.data?.attributes?.type?.toString() || '']}
          className="!mb-2 !mt-0"
          duration={knowledgebase?.attributes?.duration || undefined}
        />
      }
      image={{
        url: knowledgebase.attributes?.cover.data?.attributes?.url || '',
        alternativeText: knowledgebase.attributes?.cover.data?.attributes?.alternativeText || '',
      }}
      button={<CardButton />}
      bookmarkButton={
        showBookmarkIcon ? (
          <BookmarkButton
            relationId={knowledgebase?.id || ''}
            metadata={knowledgebase as KnowledgeBase}
            category={Enum_Bookmark_Category.KnowledgeBase}
            onRemoveFromBookmark={onRemoveFromBookmark}
            typeId={knowledgebase?.knowledgeBaseType?.documentId || ''}
          />
        ) : null
      }
    />
  );
};

export default GenericKnowledgeBaseCard;
